import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import Navigation from 'components/navigation'
import SubNavigation from 'components/sub-navigation'

import styles from './header.css'

const Header = ({ partner }) => (
  <div styleName="header">
    <RelayoutWrapper>
      <Relayout align="center">
        <RelayoutItem xl="10">
          <div styleName="content">
            <SubNavigation partner={partner} />
            {partner && <Navigation partner={partner} />}
          </div>
        </RelayoutItem>
      </Relayout>
    </RelayoutWrapper>
  </div>
)

Header.propTypes = {
  partner: PropTypes.object,
}

export default CSSModules(Header, styles)



/** WEBPACK FOOTER **
 ** ./src/components/header/header.js
 **/